import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Contrat } from '../models/contrat.model';
import { Observable } from 'rxjs/Observable';
import Api from '../../common/services/api.service';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ContratService {
    private endpoint = 'client/contrats/';
    constructor(private api: Api) { }
    getContrat(id: string): Observable<Contrat> {
         return this.api.get(this.endpoint + id);
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/services/contrat.service.ts